import CustomFetch from "components/API/customFetch";

const buildDefaultB3FileName = () => {
    const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
    return `b3-posicao-${timestamp}.xlsx`;
};

const getApiErrorMessage = async (response) => {
    const clonedResponse = response.clone();

    try {
        const data = await clonedResponse.json();
        return data?.detail || data?.message || "Nao foi possivel concluir a sincronizacao com a B3.";
    } catch (error) {
        try {
            const text = await response.text();
            return text || "Nao foi possivel concluir a sincronizacao com a B3.";
        } catch {
            return "Nao foi possivel concluir a sincronizacao com a B3.";
        }
    }
};

const getAssets = async (pageSize = 10, pageIndex = 1, orderBy = null, order = null) => {
    const url = new URL(`${process.env.REACT_APP_API}/Operations/position`);

    const requestOptions = {
        method: 'GET',
    };

    const params = {
        pageSize: pageSize ?? null,
        pageIndex: pageIndex ?? null,
        orderBy: orderBy,
        order: order
    };

    // Adiciona os parâmetros à URL
    Object.keys(params).forEach(key => {
        if (params[key] !== null) {
            url.searchParams.append(key, params[key]);
        }
    });

    try {
        const response = await CustomFetch(url, requestOptions);
        if (!response.ok) {
            throw new Error('Erro ao enviar requisição:', response.status);
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.error('Erro:', error);
        throw error;
    }
};

export const getProperty = async () => {
    const requestOptions = {
        method: 'GET',
    };

    try {
        const response = await CustomFetch(`${process.env.REACT_APP_API}/Operations/property`, requestOptions);
        if (!response.ok) {
            throw new Error('Erro ao enviar requisição:', response.status);
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.error('Erro:', error);
        throw error;
    }
};

export const getTotalPropertyValue = async () => {
    const requestOptions = {
        method: 'GET',
    };

    try {
        const response = await CustomFetch(`${process.env.REACT_APP_API}/Operations/total-property-value`, requestOptions);
        if (!response.ok) {
            throw new Error('Erro ao enviar requisição:', response.status);
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.error('Erro:', error);
        throw error;
    }
};

export const downloadB3PositionExcel = async () => {
    const requestOptions = {
        method: 'POST',
        headers: {
            Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
    };

    try {
        const response = await CustomFetch(`${process.env.REACT_APP_API}/B3/download-position-excel`, requestOptions);
        if (!response.ok) {
            throw new Error(await getApiErrorMessage(response));
        }

        const blob = await response.blob();
        const fileName = buildDefaultB3FileName();
        const downloadUrl = window.URL.createObjectURL(blob);
        const anchor = document.createElement("a");

        anchor.href = downloadUrl;
        anchor.download = fileName;
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();

        window.setTimeout(() => {
            window.URL.revokeObjectURL(downloadUrl);
        }, 1000);

        return { fileName };
    } catch (error) {
        console.error('Erro:', error);
        throw error;
    }
};

export const uploadB3PositionExcel = async (file) => {
    const formData = new FormData();
    formData.append('file', file);

    const requestOptions = {
        method: 'POST',
        headers: {
            Accept: 'application/json'
        },
        body: formData
    };

    try {
        const response = await CustomFetch(`${process.env.REACT_APP_API}/B3/upload-position-excel`, requestOptions);
        if (!response.ok) {
            throw new Error(await getApiErrorMessage(response));
        }

        return response.json();
    } catch (error) {
        console.error('Erro:', error);
        throw error;
    }
};

export const getOperationsExtract = async (pareIndex, pageSize, search, startDate, endDate) => {
    const requestOptions = {
        method: 'GET',
    };

    try {
        const response =
            await CustomFetch(`${process.env.REACT_APP_API}/Operations/operations-extract?pageSize=${pageSize}&pageIndex=${pareIndex}&startDate=${startDate}&endDate=${endDate}&search=${search}
            `
                , requestOptions);
        if (!response.ok) {
            throw new Error('Erro ao enviar requisição:', response.status);
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.error('Erro:', error);
        throw error;
    }
};

export default getAssets;
